import type { SVGProps } from "react";

import type { JSX } from "react/jsx-runtime";

export const FTCoin = (
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width="237"
      height="237"
      viewBox="0 0 237 237"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3516_16113)">
        <path
          d="M118.34 236.18C183.421 236.18 236.18 183.421 236.18 118.34C236.18 53.2588 183.421 0.5 118.34 0.5C53.2588 0.5 0.5 53.2588 0.5 118.34C0.5 183.421 53.2588 236.18 118.34 236.18Z"
          fill="white"
          stroke="#000023"
          strokeMiterlimit="10"
        />
        <path
          d="M183.12 144.28C190.87 149.41 200.12 155.28 188.51 167.54C187.521 168.578 186.417 169.5 185.22 170.29C185.22 170.29 183.22 196.18 113.22 192.37C86.0101 190.89 67.2201 183.02 54.5501 173.1C36.4701 158.95 30.8601 140.61 31.0701 130.73C31.4201 113.92 39.8201 93.6099 54.5301 88.7299C54.6201 87.9799 57.1601 66.9499 73.2701 53.5799C75.4191 51.8145 77.8058 50.3603 80.3601 49.26C96.1201 42.33 118.36 46.9199 125.81 55.0899C130.15 53.0099 153.44 43.32 172.72 63.94C179.135 65.5372 184.924 69.0204 189.34 73.94C190.398 74.9827 191.535 75.9422 192.74 76.81C198.59 81.04 195.44 87.14 195.44 87.14L195.19 87.01C195.663 87.6782 196.033 88.4129 196.29 89.19C197.91 94.01 197 98.02 194.09 100.67H194.33C194.33 100.67 198.22 105.83 188.59 109.37C189.92 110.58 195.69 116.66 195.01 127.47C199.51 126.55 198.37 130.66 198.37 130.66C196.39 141.46 183.12 144.28 183.12 144.28Z"
          fill="#77AE46"
        />
        <path
          opacity="0.9"
          d="M198.36 130.64C198.36 130.64 200.07 124.46 191 128.93C173.63 137.49 158.29 139.14 141.6 138.39C101.48 136.6 88.6001 126.5 74.8301 121.64C61.0601 116.78 53.1301 122.41 55.1201 132.28C56.8601 140.92 81.5101 164.1 116.12 172.16C143.48 178.53 176.93 179.78 188.5 167.56C200.07 155.34 190.86 149.43 183.11 144.3C183.12 144.3 196.39 141.48 198.36 130.64Z"
          fill="#A75547"
        />
        <path
          opacity="0.57"
          d="M105.01 45.8201C79.5899 45.8201 62.0098 73.2401 66.3598 96.9201C66.3598 96.9201 53.4798 95.5201 43.8498 110.41C33.2498 126.79 33.6298 144.73 54.5398 173.08C36.4598 158.93 30.8498 140.59 31.0598 130.71C31.4098 113.9 39.8099 93.59 54.5199 88.71C54.6099 87.96 57.1499 66.9301 73.2599 53.5601C75.3899 51.7501 82.3099 44.6501 105.01 45.8201Z"
          fill="#004205"
        />
        <path
          opacity="0.57"
          d="M125.8 55.01C125.8 55.01 128.18 57.87 128.53 59.86C128.53 59.86 129.89 60.52 130.88 60.92C130.88 60.92 143.61 50.3 163.69 56.41C163.69 56.43 149.3 45.8 125.8 55.01Z"
          fill="#004205"
        />
        <path
          d="M145.52 98.1199L145.45 98.2099C144.394 99.6545 143.161 100.961 141.78 102.1C138.895 104.429 135.368 105.825 131.67 106.1C126.89 106.62 121.56 105.82 116.18 104.41C107.61 102.17 98.9 98.41 92.03 95.82C77.4 90.39 88.24 84.4799 88.24 84.4799C96.3998 80.6933 105.096 78.1905 114.02 77.06C126.25 75.63 135.09 77.64 139.02 79.06L139.49 79.2299C142.576 80.5439 145.108 82.8918 146.65 85.8699V85.94C148.43 89.38 148.69 93.6499 145.52 98.1199Z"
          fill="white"
        />
        <path
          d="M195.73 98.01C194.98 99.39 193.44 101.53 189.05 103.1C185.23 104.47 179.24 105.41 169.72 105.02C168.34 104.96 167.04 104.88 165.81 104.78C148.81 103.41 145.45 98.17 145.45 98.17L145.52 98.0799C146.18 97.2299 150.87 90.7999 146.73 85.9499V85.89C159.963 80.5972 174.455 79.2936 188.42 82.14L188.72 82.2099C199.19 84.7299 197.19 95.5 195.73 98.01Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M139.94 111.25C139.94 111.25 136.48 127.66 109.94 119.43C83.4 111.2 86.07 96.5701 86.07 96.5701C86.07 96.5701 91.46 106.73 106.26 110.67C126.64 116.11 133.37 113.12 139.94 111.25Z"
          fill="#004205"
        />
        <path
          opacity="0.4"
          d="M188.58 109.33C188.58 109.33 190.5 118.33 175.22 117.76C159.94 117.19 155.13 109 154.74 106.9C154.74 106.9 170.87 116.75 188.58 109.33Z"
          fill="#004205"
        />
        <path
          d="M142.89 89.9499C142.89 93.4698 141.816 96.906 139.811 99.799C137.806 102.692 134.966 104.904 131.67 106.14C126.89 106.66 121.56 105.86 116.18 104.45C113.957 103.005 112.096 101.068 110.74 98.7893C109.385 96.5104 108.571 93.9504 108.362 91.3071C108.154 88.6638 108.555 86.0078 109.536 83.5444C110.517 81.081 112.051 78.8761 114.02 77.0999C126.25 75.6699 135.09 77.6799 139.02 79.0999C141.514 82.1671 142.88 85.9969 142.89 89.9499Z"
          fill="#56568A"
        />
        <path
          d="M192.73 92.89C192.74 96.6319 191.438 100.259 189.05 103.14C185.23 104.51 179.24 105.45 169.72 105.06C168.34 105 167.04 104.92 165.81 104.82C164.16 103.327 162.838 101.508 161.927 99.4775C161.017 97.4471 160.538 95.2497 160.521 93.0245C160.504 90.7993 160.949 88.5949 161.829 86.5509C162.708 84.5068 164.003 82.6677 165.63 81.15C173.217 80.2273 180.904 80.5652 188.38 82.15L188.68 82.22C191.302 85.1539 192.745 88.955 192.73 92.89Z"
          fill="#56568A"
        />
        <path
          opacity="0.84"
          d="M94.3498 140.73C94.3498 140.73 73.3499 130.38 69.9499 131.6C66.5499 132.82 67.7599 137.38 75.0299 142.81C82.2999 148.24 113.3 165.81 143.03 166.81C172.76 167.81 182.51 162.34 183.22 156.01C183.93 149.68 168.7 146.91 168.7 146.91C168.7 146.91 159.24 149.85 131.47 146.52C103.7 143.19 94.3498 140.73 94.3498 140.73Z"
          fill="#3B0505"
        />
        <path
          d="M185.19 170.31C185.19 170.31 183.19 196.2 113.19 192.39C47.1898 188.8 30.6798 147.54 31.0298 130.73C31.3798 113.92 39.7898 93.59 54.4998 88.73"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.5298 88.6801C54.5298 88.6801 56.8598 67.12 73.2598 53.51C89.6598 39.9 121.52 46.33 127.43 57.27"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M125.99 55.2399C125.99 55.2399 151.34 41.72 171.46 63.14"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.02 65.2399C146.02 65.2399 172.53 55.3099 189.32 73.8599"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M149.3 76.18C149.3 76.18 174.76 63.7499 192.73 76.7299C198.58 80.9599 195.43 87.06 195.43 87.06"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.19 84.52C146.19 84.52 152.51 76.69 143.32 71.82C135.32 67.57 116.04 60.7499 89.0698 73.6299"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M141.77 70.38C141.77 70.38 139.77 60.94 120 58.87C94.3798 56.19 83.2598 65.54 79.5898 70.38"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M145.7 99.92C145.7 99.92 149.31 107.69 137.7 111.54C126.09 115.39 113.7 113.3 101.96 109.09C90.2201 104.88 86.0601 96.92 86.0601 96.92"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M194.32 100.62C194.32 100.62 198.23 105.81 188.51 109.35C178.79 112.89 164.72 111.24 155.35 106.97"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M194.95 126.17C195.49 115 188.51 109.35 188.51 109.35C188.51 109.35 192.51 121.46 162.62 116.35"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M198.36 130.64C198.36 130.64 200.07 124.46 191 128.93C173.63 137.49 158.29 139.14 141.6 138.39C101.48 136.6 88.6001 126.5 74.8301 121.64C61.0601 116.78 53.1301 122.41 55.1201 132.28C56.8601 140.92 81.5101 164.1 116.12 172.16C143.48 178.53 176.93 179.78 188.5 167.56C200.07 155.34 190.86 149.43 183.11 144.3C183.12 144.3 196.39 141.48 198.36 130.64Z"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M171.37 146.82C174.351 147.978 177.192 149.468 179.84 151.26C185.62 155.73 184.57 160.72 172.35 165.32C170.805 165.894 169.212 166.332 167.59 166.63C160.99 167.91 152.59 167.74 143.93 166.87C135.79 166.06 127.46 164.63 120.32 163.22C103.63 159.94 66.9702 142.9 68.7202 133.22C69.7902 127.22 81.7202 137.7 97.3302 141.51C104.71 143.31 111.72 144.65 118.33 145.63C131.165 147.582 144.159 148.292 157.13 147.75C173.67 147.01 183.13 144.26 183.13 144.26"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M158.03 182.4C150.33 183.04 147.69 174.5 143.93 166.87C142.669 164.089 140.982 161.521 138.93 159.26C133.13 153.285 126.097 148.647 118.32 145.67C133.66 147.94 159.73 147.67 159.73 147.67C162.32 150.768 164.449 154.223 166.05 157.93C167.199 160.663 167.985 163.533 168.39 166.47C169.6 174.17 166.65 181.68 158.03 182.4Z"
          fill="#E6818D"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M87.4702 84.85C96.2202 81 104.32 78.31 114.56 77.2H114.93C119.112 76.7679 123.319 76.6343 127.52 76.8C130.593 76.8815 133.642 77.3621 136.59 78.23C137.02 78.36 137.44 78.5 137.86 78.65C146.63 81.77 151.29 88.65 144.86 98.92C142.909 101.884 139.87 103.96 136.4 104.7C129.75 106.44 120.98 105.12 112.93 102.97C105.469 100.837 98.1564 98.2148 91.0402 95.12"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M150.34 84.1601C155.202 83.0304 160.123 82.1724 165.08 81.59C173.08 80.66 182.52 80.3401 189.08 82.6901C192.61 83.9501 195.26 86.0101 196.33 89.1801C198.54 95.7501 196.04 100.81 190.21 102.99C189.8 103.14 189.37 103.29 188.93 103.42C182.6 105.42 173.5 105.42 165.21 104.42C161.583 104.012 157.986 103.374 154.44 102.51C151.105 101.709 147.885 100.486 144.86 98.8701"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M143 91.01C143.004 93.6471 142.408 96.2505 141.255 98.6226C140.103 100.995 138.426 103.073 136.35 104.7C129.7 106.44 120.93 105.12 112.88 102.97C111.209 101.2 109.927 99.0994 109.116 96.8041C108.306 94.5087 107.984 92.0691 108.172 89.6421C108.361 87.2151 109.055 84.8542 110.21 82.7114C111.365 80.5686 112.956 78.6912 114.88 77.2C119.062 76.7679 123.269 76.6343 127.47 76.8C130.543 76.8815 133.592 77.3621 136.54 78.23C136.97 78.36 137.39 78.5 137.81 78.65C139.451 80.2637 140.755 82.1874 141.646 84.3092C142.536 86.431 142.997 88.7087 143 91.01Z"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M192.73 93.01C192.739 96.842 191.373 100.55 188.88 103.46C182.55 105.46 173.45 105.46 165.16 104.46C162.128 101.438 160.417 97.3374 160.402 93.0565C160.387 88.7756 162.069 84.6632 165.08 81.62C173.08 80.69 182.52 80.37 189.08 82.72C191.458 85.6201 192.749 89.2596 192.73 93.01Z"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128.69 102.1C134.677 102.1 139.53 97.2468 139.53 91.26C139.53 85.2733 134.677 80.42 128.69 80.42C122.703 80.42 117.85 85.2733 117.85 91.26C117.85 97.2468 122.703 102.1 128.69 102.1Z"
          fill="#000023"
        />
        <path
          d="M179.88 102.42C185.094 102.42 189.32 98.1936 189.32 92.98C189.32 87.7665 185.094 83.54 179.88 83.54C174.666 83.54 170.44 87.7665 170.44 92.98C170.44 98.1936 174.666 102.42 179.88 102.42Z"
          fill="#000023"
        />
        <path
          d="M76.56 114.28C76.56 114.28 62.3799 107.93 51.7299 116.34C40.0399 125.58 47.53 136.42 47.53 136.42"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.53 111.25C139.53 111.25 137.67 127.11 109.41 119.25"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.58 147.51C144.58 147.51 153.34 152.27 156.05 164.45"
          stroke="#000023"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.8"
          d="M95.4902 52.5999C95.4902 52.5999 108.09 47.87 116.6 54.17"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.8"
          d="M151.26 56.1C154.595 55.9305 157.868 57.0513 160.4 59.23"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.7"
          d="M81.9199 73.85C81.9199 73.85 89.3399 65.31 100.05 64.39"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.7"
          d="M149.88 69.87C155.24 66.7936 161.558 65.8341 167.59 67.1801"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.8"
          d="M188.66 117.79C188.66 117.79 190.41 119.73 190.21 124.86"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g opacity="0.46">
          <path
            d="M128.74 87.39H132.62C132.668 87.3873 132.716 87.3981 132.758 87.421C132.801 87.444 132.836 87.4782 132.86 87.52L133.86 88.9301C133.893 88.9784 133.917 89.0327 133.93 89.09C133.874 89.0991 133.816 89.0991 133.76 89.09H126.55C126.43 89.09 126.4 89.15 126.46 89.25C126.6 89.5 126.75 89.74 126.89 89.98L130 95.3001C130.032 95.3319 130.05 95.3751 130.05 95.4201C130.05 95.465 130.032 95.5082 130 95.5401L128.8 97.24C128.69 97.39 128.66 97.39 128.56 97.24L125.51 92.33C124.87 91.33 124.22 90.26 123.58 89.23C123.55 89.197 123.534 89.1543 123.534 89.11C123.534 89.0657 123.55 89.023 123.58 88.99C123.95 88.49 124.32 87.99 124.68 87.47C124.705 87.4355 124.738 87.4077 124.777 87.3886C124.815 87.3694 124.857 87.3596 124.9 87.36L128.74 87.39Z"
            fill="white"
          />
          <path
            d="M130.32 90.5201H131.41C131.449 90.5162 131.489 90.5235 131.524 90.5412C131.56 90.5589 131.59 90.5862 131.61 90.62C131.86 91.01 132.12 91.3901 132.39 91.7801C132.41 91.806 132.42 91.8376 132.42 91.87C132.42 91.9025 132.41 91.934 132.39 91.96L131.19 93.8101C131.12 93.9101 131.07 93.9101 131.01 93.8101L129.09 90.6901C129.02 90.5701 129.09 90.5201 129.2 90.5201H130.32Z"
            fill="white"
          />
        </g>
        <g opacity="0.46">
          <path
            d="M179.94 88.89H183.82C183.868 88.8873 183.916 88.8981 183.958 88.9211C184.001 88.944 184.036 88.9783 184.06 89.0201L185.06 90.4201C185.089 90.4741 185.113 90.531 185.13 90.59C185.073 90.5935 185.017 90.5935 184.96 90.59H177.74C177.63 90.59 177.6 90.64 177.66 90.75L178.09 91.48C179.117 93.2467 180.153 95.0167 181.2 96.7901C181.228 96.8255 181.244 96.8696 181.244 96.9151C181.244 96.9605 181.228 97.0046 181.2 97.0401L179.99 98.74C179.89 98.89 179.86 98.89 179.76 98.74C178.74 97.1 177.74 95.4601 176.76 93.8201C176.11 92.8201 175.47 91.75 174.83 90.72C174.801 90.6886 174.785 90.6476 174.785 90.605C174.785 90.5624 174.801 90.5214 174.83 90.49C175.2 89.99 175.56 89.49 175.93 88.97C175.952 88.9343 175.983 88.9053 176.02 88.8859C176.057 88.8665 176.098 88.8576 176.14 88.86L179.94 88.89Z"
            fill="white"
          />
          <path
            d="M181.52 92.0101H182.61C182.648 92.0056 182.687 92.0128 182.72 92.0307C182.754 92.0485 182.782 92.0762 182.8 92.11L183.58 93.2801C183.591 93.2912 183.6 93.3044 183.606 93.319C183.612 93.3336 183.615 93.3492 183.615 93.365C183.615 93.3808 183.612 93.3965 183.606 93.4111C183.6 93.4256 183.591 93.4389 183.58 93.45L182.38 95.3101C182.31 95.4101 182.26 95.4101 182.2 95.3101L180.28 92.1901C180.21 92.0701 180.28 92.0201 180.39 92.0201L181.52 92.0101Z"
            fill="white"
          />
        </g>
        <path
          opacity="0.9"
          d="M121.661 83.6008C122.549 82.9838 122.572 81.4814 121.712 80.245C120.853 79.0087 119.437 78.5066 118.549 79.1236C117.661 79.7406 117.639 81.2431 118.498 82.4794C119.357 83.7158 120.774 84.2178 121.661 83.6008Z"
          fill="white"
        />
        <path
          opacity="0.9"
          d="M175.355 88.0569C176.163 87.496 176.184 86.1294 175.402 85.0046C174.621 83.8797 173.333 83.4226 172.525 83.9835C171.718 84.5444 171.697 85.911 172.478 87.0358C173.26 88.1607 174.548 88.6178 175.355 88.0569Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3516_16113">
          <rect width="236.69" height="236.69" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
